import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'

const RitBlockButtons = ({
    value,
    onChange,
    checked,
    children,
    themeClass,
    displayName,
    showLabel,
    style,
    disabled,
}) => {

    const rootRef = useRef()

    let checkedClass = '';
    let checkedLabel = '';
    if (checked) {
        checkedClass = 'b-rit-list__item_checked';
        checkedLabel = (
            <span className='b-rit-list__check-label' />
        );
    }

    const rootClassName = classnames(
        'b-rit-list__wrapper',
        themeClass,
        disabled ? `${themeClass}_disabled` : '',
      )

    return (
        <label className={rootClassName} style={style}>
            <div ref={rootRef}
                className={`b-rit-list__item ${checkedClass} ${themeClass}`}
            >
                {checkedLabel}
                <input
                    type='radio'
                    checked={checked}
                    value={value}
                    className='b-rit-list__fake-input'
                    onChange={
                        (e) => onChange(e.target.value)
                    }
                    disabled={disabled}
                />
                {children}
            </div>
            {showLabel && displayName}
        </label>
    );
}

RitBlockButtons.propTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    children: PropTypes.object.isRequired,
    themeClass: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    showLabel: PropTypes.bool,
    style: PropTypes.object,
    disabled: PropTypes.bool,
}

export default RitBlockButtons;